module.exports = __webpack_public_path__ + "img/19800.1e680e25.jpg";